import { jsx as l } from "react/jsx-runtime";
const i = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.5 1.5h-3.999V3H13v10l1.5-.401V1.5ZM13 13H3v-2.5H1.5v4h11.903L13 13ZM1.5 5.034 5.035 1.5 10.5 6.963V10.5H6.963L1.5 5.035Zm4.383-.566-.848-.848-1.413 1.414.847.848 1.414-1.414Zm1.702 4.53h1.414V7.585L6.943 5.53 5.53 6.944l2.055 2.055Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  i as Edit
};
